var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { paragraphCls, paragraphCenterCls, paragraphRightCls, paragraphUpperCaseCls, paragraphNormalCaseCls, paragraphLevel1Cls, paragraphLevel2Cls, paragraphLevel3Cls, paragraphLevel4Cls, paragraphLevel5Cls, paragraphLevel6Cls } from "./Paragraph.less";
var ALIGN_CLASSNAMES = {
  center: paragraphCenterCls,
  right: paragraphRightCls
};
var LEVEL_CLASSNAMES = [paragraphLevel1Cls, paragraphLevel2Cls, paragraphLevel3Cls, paragraphLevel4Cls, paragraphLevel5Cls, paragraphLevel6Cls];
function Paragraph(_ref) {
  var _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? null : _ref$tag, level = _ref.level, _ref$align = _ref.align, align = _ref$align === void 0 ? "left" : _ref$align, _ref$uppercase = _ref.uppercase, uppercase = _ref$uppercase === void 0 ? null : _ref$uppercase, className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$innerHtml = _ref.innerHtml, innerHtml = _ref$innerHtml === void 0 ? null : _ref$innerHtml, style = _ref.style;
  var DEFAULT_TAG = "p";
  var Component = tag || DEFAULT_TAG;
  var levelNumber = level && parseInt(level, 10);
  var levelIndex = levelNumber && levelNumber > 0 && levelNumber < 7 ? levelNumber - 1 : null;
  return /* @__PURE__ */ React.createElement(Component, _extends({
    className: classNames(paragraphCls, typeof levelIndex === "number" ? LEVEL_CLASSNAMES[levelIndex] : null, ALIGN_CLASSNAMES[align], _defineProperty({}, paragraphUpperCaseCls, uppercase), _defineProperty({}, paragraphNormalCaseCls, uppercase === false), className)
  }, style ? {
    style
  } : null, innerHtml ? {
    dangerouslySetInnerHTML: {
      __html: innerHtml
    }
  } : null), innerHtml ? null : children);
}
__name(Paragraph, "Paragraph");
export {
  Paragraph
};
